import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import React, {  useState } from "react";
import { useDispatch } from "react-redux";
import { insertVoucher } from "src/features/voucherSlice";
import EnhancedConfirmButton from "src/components/enhanced/EnhancedConfirmButton";
import EnhancedTextField from "src/components/enhanced/EnhancedTextField";
import {  fetchVoucherPrices } from "src/features/paymentSlice";
import alertHelper from "src/helpers/alertHelper";
import PaymentTypeResolver from "src/helpers/paymentTypeResolver";
import { getSessionCheckedCompany } from "src/helpers/sessionHelper";
import EnhancedDialogTitle from "src/components/enhanced/EnhancedDialogTitle";
import EnhancedTicketPayment from "src/components/enhanced/EnhancedTicketPayment";
import EnhancedDateField from "src/components/enhanced/EnhancedDateField";

function NewVoucherDialog(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { open, setOpenNew } = props;

  const [formState, setFormState] = useState({});
  const [startDate] = useState(new moment().add(6, "months").format("YYYY-MM-DD"));

  const handleChange = (event) => {
    event.persist();
    setFormState((formState) => ({
      ...formState,
      [event.target.name]: event.target.value
    }));
  };

  const handleClose = () => {
    setOpenNew(false);
    setFormState({});
  };

  const handlePayAndSave = () => {
    if (!formState.title) {
      alertHelper.error({ message: "Musíte zadat titulek dárkového poukazu!" });
      return false;
    }

    if (!formState.paymentTypeId) {
      alertHelper.error({ message: "Musíte zadat typ platby!" });
      return false;
    }

    if (PaymentTypeResolver.isBill(formState.paymentTypeId) && !formState.billNumber) {
      alertHelper.error({ message: "Musíte zadat číslo faktury!" });
      return false;
    }

    if (!formState.typeOfMassageId) {
      alertHelper.error({ message: "Musíte zadat typ masáže!" });
      return false;
    }

    const apiData = {};
    apiData.companyId = getSessionCheckedCompany();
    apiData.title = formState.title;
    apiData.dateExpire = formState.dateExpire || startDate;
    apiData.paymentTypeId = formState.paymentTypeId;
    apiData.createNumber = formState.createNumber || 1;
    apiData.massageTypeId = formState.typeOfMassageId;
    apiData.billUUID = formState.billNumber;
    apiData.invoiceAddress = formState.invoiceAddress;

    alertHelper.confirm({
      message: "Opravdu si přejete uložit a zaplatit dárkový poukaz?",
      callback: () => dispatch(insertVoucher(apiData))
    });

    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md" aria-labelledby="form-dialog-title">
        <EnhancedDialogTitle handleClose={handleClose} nameLabel="Nový dárkový poukaz" />
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <EnhancedTextField name="title" value={formState.title} label="Jméno" onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <EnhancedDateField
                  name="dateExpire"
                  label="Platnost do"
                  value={formState.dateExpire || startDate}
                  handleChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <EnhancedTextField
                  name="createNumber"
                  value={formState.createNumber}
                  label="Počet vytvoření"
                  onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <EnhancedTicketPayment
                formState={formState}
                open={open}
                handleChange={handleChange}
                disabled={false}
                fetchPriceMethod={fetchVoucherPrices}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <EnhancedConfirmButton handleClose={handleClose} handleOk={handlePayAndSave} okLabel="Uložit a zaplatit" />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  }
}));

export default NewVoucherDialog;
